'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var avatarImagePlaceholder = require('../../../images/avatar-image-placeholder.svg.js');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var Avatar = /*#__PURE__*/function (_React$PureComponent) {
  _rollupPluginBabelHelpers.inherits(Avatar, _React$PureComponent);

  var _super = _rollupPluginBabelHelpers.createSuper(Avatar);

  function Avatar() {
    _rollupPluginBabelHelpers.classCallCheck(this, Avatar);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(Avatar, [{
    key: "getInitials",
    value: function getInitials() {
      var numberOfPersons = this.props.persons ? this.props.persons.length : this.props.numberOfPersons;
      if (numberOfPersons > 1) return "+".concat(numberOfPersons);
      var personName = this.props.persons.length > 0 ? this.props.persons[0].name : this.props.personName;
      var name = personName.trim().split(/\s+/);
      if (this.props.showInitials && !personName) return '?';
      return name.length > 1 ? "".concat(name[0][0].toUpperCase()).concat(name[1][0].toUpperCase()) : name[0][0];
    }
  }, {
    key: "calculateClassName",
    value: function calculateClassName() {
      var numberOfPersons = this.props.persons ? this.props.persons.length : this.props.numberOfPersons;

      if (!numberOfPersons) {
        var personName = this.props.persons.length > 0 ? this.props.persons[0].name : this.props.personName;
        if (this.props.showInitials && !personName) return "ds-atom-avatar-unknown ".concat(this.props.className);
      }

      if (this.props.size === 'tiny') return "ds-atom-avatar-tiny ".concat(this.props.className);
      if (this.props.size === 'small') return "ds-atom-avatar-small ".concat(this.props.className);
      if (this.props.size === 'big') return "ds-atom-avatar-big ".concat(this.props.className);
      return "ds-atom-avatar-medium ".concat(this.props.className);
    }
  }, {
    key: "render",
    value: function render() {
      var personName = this.props.personName ? this.props.personName : this.props.persons.name;
      var imageRoute = this.props.imageRoute ? this.props.imageRoute : this.props.persons.imageRoute;
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: this.calculateClassName()
      }, this.props.showInitials || this.props.numberOfPersons ? /*#__PURE__*/React__default['default'].createElement("span", {
        className: "ds-atom-avatar-with-text"
      }, this.getInitials()) : /*#__PURE__*/React__default['default'].createElement("img", {
        alt: personName || 'default',
        className: "ds-atom-avatar-image",
        src: imageRoute || avatarImagePlaceholder
      }));
    }
  }]);

  return Avatar;
}(React__default['default'].PureComponent);

_rollupPluginBabelHelpers.defineProperty(Avatar, "propTypes", {
  className: PropTypes__default['default'].string,
  imageRoute: PropTypes__default['default'].string,
  showInitials: PropTypes__default['default'].bool,
  numberOfPersons: PropTypes__default['default'].number,
  size: PropTypes__default['default'].string,
  personName: PropTypes__default['default'].string,
  persons: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape)
});

_rollupPluginBabelHelpers.defineProperty(Avatar, "defaultProps", {
  className: '',
  imageRoute: avatarImagePlaceholder,
  numberOfPersons: 0,
  personName: '',
  showInitials: false,
  size: '',
  persons: []
});

module.exports = Avatar;
